import { createFileRoute } from "@tanstack/react-router";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";

export const Route = createFileRoute("/_adminLayout/admin/newsletters")({
  component: AdminNewsletter,
});
